export var DEFAULT_CATEGORY = {
    industryId: '9e0d43c23f82998a6ac269b5',
    structureId: 'e51e11f3597e0c565deb792f',
};
//# sourceMappingURL=defaultCategory.js.map